module.exports = __webpack_public_path__ + "static/media/superhero.bc316685.webp";